import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissions } from "../../context/PermissionContext";
import Loader from "./Loader";

const PermissionRoute = ({ permission, redirectTo = "/business", children }) => {
  const { hasPermission, loading } = usePermissions();

  // Show a loader while permissions are being fetched
  if (loading) {
    return <Loader message="Checking permissions..." size="medium" />;
  }

  if (!hasPermission(permission)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default PermissionRoute;